import React, { useCallback } from 'react';
import QuizContent from '../shared/QuizContent';
import VideoCarousel from '../shared/VideoCarousel';
import { getQuizOptionsData } from '../../constants';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useDesign } from '../../contexts/DesignContext';

const Step2Body = ({ onAnswer, onPrevious, selections, isTransitioning }) => {
  const { t } = useTranslation();
  const { isNewDesign } = useDesign();
  const location = useLocation();

  const selectedStyle = location.pathname.includes('/create-ai-hentai')
    ? 'Anime'
    : location.pathname.includes('/create-ai-porn')
    ? 'Realistic'
    : selections?.welcome || 'Realistic';

  const isHalloween = !!location.pathname.includes('/halloween');

  const bodyTypes = getQuizOptionsData('bodyType', selectedStyle);

  const [selectedBodyType, setSelectedBodyType] = React.useState(
    bodyTypes[0]?.value || '',
  );

  const handleContinue = useCallback(() => {
    if (isTransitioning || !selectedBodyType) return;

    onAnswer('step2_body', {
      bodyType: selectedBodyType,
    });
  }, [selectedBodyType, onAnswer, isTransitioning]);

  const handlePrevious = useCallback(() => {
    if (isTransitioning) return;
    onPrevious();
  }, [onPrevious, isTransitioning]);

  const title = isHalloween || isNewDesign ? (
    <>
      {t('choose')}
      <span className="specialText"> {t('body_text')}</span>
    </>
  ) : (
    t('choose_body')
  );

  return (
    <div className={`quizContentWrapper ${isTransitioning ? 'no-click' : ''}`}>
      <QuizContent className="step4-5-design">
        <VideoCarousel
          items={bodyTypes}
          title={title}
          selectedValue={selectedBodyType}
          onSelect={setSelectedBodyType}
          isTransitioning={isTransitioning}
          forceShowVideos={true}
        />

        <div className="navigation-wrapper step4-5-navigation-wrapper">
          <button
            className="previous-button"
            onClick={handlePrevious}
            disabled={isTransitioning}
          >
            {t('previous')}
          </button>
          <button
            className="continue-button"
            onClick={handleContinue}
            disabled={!selectedBodyType || isTransitioning}
          >
            {t('next')}
          </button>
        </div>
      </QuizContent>
    </div>
  );
};

export default Step2Body;
